import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createLabelNotificationTitle: {
    defaultMessage: 'Processing...',
    description: 'Notification title shown when creating a return label',
    id: 'r16uRi',
  },
  createLabelNotificationContent: {
    defaultMessage: 'Creating return and {downloadLabelNow, select, true {downloading label} other {sending label via email}}.',
    description: 'Notification content shown when creating a return label',
    id: 'izHlup',
  },
});
